import { cn } from '../../lib/cn';
import {
  EMAIL_CONSENT_BASIS_LABEL,
  EMAIL_CONTACT_STATUS,
  type EmailConsentBasis,
  type EmailContactStatus,
} from '../../types/email.types';

interface ConsentBadgeProps {
  status: EmailContactStatus;
  basis?: EmailConsentBasis | null;
  /** Mostra anche su quale base giuridica gli stiamo scrivendo. */
  mostraBase?: boolean;
  className?: string;
}

/**
 * Stato del consenso di un contatto.
 *
 * Il suggerimento al passaggio del mouse spiega cosa vuol dire lo stato: chi
 * usa la pagina non deve dover ricordare la differenza fra "disiscritto" e
 * "bloccato" per capire perche' una persona non riceve le mail.
 */
export function ConsentBadge({ status, basis, mostraBase = false, className }: ConsentBadgeProps) {
  const descrizione = EMAIL_CONTACT_STATUS[status];

  return (
    <span className={cn('inline-flex items-center gap-1.5', className)} title={descrizione.spiegazione}>
      <span
        className={cn(
          'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full border text-[10px] font-bold uppercase tracking-wide',
          descrizione.badge
        )}
      >
        <span className={cn('w-1.5 h-1.5 rounded-full', descrizione.puntino)} />
        {descrizione.label}
      </span>
      {mostraBase && basis && (
        <span className="text-[11px] text-neutral-500">{EMAIL_CONSENT_BASIS_LABEL[basis]}</span>
      )}
    </span>
  );
}
